<template>
	<div>
		<div class="header-item">
			<h1>Hosting</h1>
		</div>

		<div class="white">
			<div class="row">
				<div class="col-20">

					<div class="toolbar">
						<nav class="subnav">
							<ul>
								<li><router-link to="/hosting">CMS sites</router-link></li>
								<li><router-link to="/hosting/vhosts">Vhosts</router-link></li>
								<li>
									<div class="dropdown search">
										<a href="#"><i class="fa fa-search"></i></a>
										<div class="popup">

											<div class="searchfield">
												<input type="text" placeholder="Search...">
											</div>

										</div>
									</div>
								</li>
							</ul>
						</nav>
					</div>

				</div>
			</div>
		</div>

		<router-view></router-view>

	</div>

</template>

<script>

export default {
	name: 'hosting'
}
</script>
